/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubstituteApplyTodoInfo { 
    /**
     * 代理人申請ID
     */
    substituteApplyId?: number;
    /**
     * 代理起始時間
     */
    substituteFrom?: Date;
    /**
     * 代理結束時間
     */
    substituteTo?: Date;
    /**
     * 申請人員工編號
     */
    applicant?: string;
    /**
     * 申請人姓名
     */
    applicantName?: string;
    /**
     * 被代理人
     */
    principalSubstitute?: string;
    /**
     * 被代理人姓名
     */
    principalSubstituteName?: string;
    /**
     * 代辦事項代理人
     */
    todoItemSubstitute?: string;
    /**
     * 代辦事項代理人姓名
     */
    todoItemSubstituteName?: string;
    processId?: string;
    taskId?: string;
    processDefKey?: string;
    /**
     * 狀態
     */
    statusCode?: string;
}